module.exports = __webpack_public_path__ + "static/media/profile_background.3064c78a.jpg";